<template>
  <div>
    <el-page-header
      class="page-header"
      @back="goBack"
      content="文章详情"
    ></el-page-header>
    <div id="new-detail" class="dashboard-container">
      <div class="nav">
        <h1>{{ list.title }}</h1>
      </div>
      <div class="desc">
        <span class="auchor" v-if="list.author">发布人：{{ list.author }}</span>
        <span v-if="list.author">|</span>
        <span class="addtime">发布时间：{{ list.addtime }}</span>
      </div>
      <div class="body" v-html="list.content"></div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "notice",
  data() {
    return {
      crm: {},
      list: {},
    };
  },
  created() {
    this.getList();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getList() {
      this.axios
        .post(
          "/api/notice/lookNotice",
          qs.stringify({
            id: this.$route.query.id,
            scope: 0
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          this.list = res.data.data.data[0];
        })
        .catch(function (err) {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard {
  &-container {
    margin: 3.0rem;
    padding: .4rem 0;
    background-color: #fff;
  }
  &-text {
    font-size: 3.0rem;
    line-height: 4.6rem;
  }
}
.nav {
  font-size: 1.8rem;
  text-align: center;
  font-weight: bold;
}
.desc {
  text-align: center;
  color: #888;
}

.auchor {
  margin-right: 2.0rem;
}
.addtime {
  margin-left: 2.0rem;
}

#new-detail {
  width: 96%;
}
.body {
  width: 94%;
  background-color: #fff;
  margin: 0 auto;
  margin-top: 5.0rem;
  font-size: 1.8rem;
  line-height: 2.2rem;
}
</style>
